module.exports = __webpack_public_path__ + "img/cash.e4434a24.svg";